import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { colors } from "utils";

export const EducatorBanner = ({ teacher, onBack }) => (
  <BannerWrapper>
    <BackButton onClick={onBack}>
      <FontAwesomeIcon icon={faArrowLeft} />
      <span>Change Teacher</span>
    </BackButton>
    <EducatorInfo>
      Generating report for: <strong>{teacher.name}</strong>
      {teacher.email && <span> ({teacher.email})</span>}
    </EducatorInfo>
  </BannerWrapper>
);

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 32px;
  background-color: ${colors.blue50};
  border-bottom: 1px solid ${colors.blue200 || "#bfdbfe"};
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: ${colors.blue500};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${colors.blue100 || "rgba(59, 130, 246, 0.1)"};
  }
`;

const EducatorInfo = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: ${colors.nightlyWoods500};
`;
